module.exports = __webpack_public_path__ + "static/img/kongtiao-zhire.a313e573.gif";